import { render } from "./RoleDetail.vue?vue&type=template&id=945066aa&scoped=true&ts=true"
import script from "./RoleDetail.vue?vue&type=script&lang=ts"
export * from "./RoleDetail.vue?vue&type=script&lang=ts"

import "./RoleDetail.vue?vue&type=style&index=0&id=945066aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945066aa"]])

export default __exports__